import React from "react";
import { APStatus, priorities } from "../../constant/assistanceProgram";
import { WaitList, Close, Open, WaitListOnly } from "./index";

export const ApplicationStatusTag = ({ status, priority }) => {
  return (
    <>
      {status === APStatus.WAITLIST && <WaitList />}
      {status === APStatus.CLOSED && <Close />}
      {priority === priorities.COPAY.value && status === APStatus.OPEN && <Open />}
      {status === APStatus.WAITLIST_ONLY && <WaitListOnly />}
    </>
  );
};
